<template>
<div class="chapter">
<div class="inner_page">
<p class="pn"><a id="page_15"></a><a href="#/contenttoc#t5" id="c5">PART I</a></p>
<p class="pt"><a href="#/contenttoc#t5">Preparation and Messaging</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?28e78db6